import { render, staticRenderFns } from "./outputManagementTabs.vue?vue&type=template&id=28b2e5c4&scoped=true&"
import script from "./outputManagementTabs.vue?vue&type=script&lang=js&"
export * from "./outputManagementTabs.vue?vue&type=script&lang=js&"
import style0 from "./outputManagementTabs.vue?vue&type=style&index=0&id=28b2e5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2e5c4",
  null
  
)

export default component.exports